import { BrandLogoMark } from "@v1/ui/brand-logo-mark";
import { Calculator, RefreshCw } from "lucide-react";
import { useTranslations } from "next-intl";
import type { CSSProperties, ReactNode } from "react";

/** What the chaos becomes: two programs with the customer's ERP, one with our accounting. ERP first. */
export type StageWay = "erp" | "books";

export const STAGE_WAYS: readonly StageWay[] = ["erp", "books"];

/** Tile edge in canvas px at scale 1; the canvas aims the flying windows at its center. */
export const STAGE_TILE = 144;

/** One app tile, or two joined by the sync badge. `scale` undoes the phone stage scale. */
export function StageResult(props: { readonly way: StageWay; readonly scale: number }): ReactNode {
  const t = useTranslations("marketing.scrollStage");
  const tile = STAGE_TILE * props.scale;
  return (
    <div className="mkss-result" data-way={props.way} style={{ "--mkss-s": props.scale } as CSSProperties}>
      <div className="mkss-link" aria-hidden="true">
        <span className="mkss-link-line" />
        <span className="mkss-link-badge">
          <span className="mkhero-syncring mkss-link-ring" />
          <RefreshCw size={20 * props.scale} strokeWidth={2.2} style={{ position: "relative" }} />
        </span>
      </div>
      <div className="mkss-app mkss-app-erp" aria-hidden={props.way !== "erp"}>
        <span className="mkss-tile mkss-tile-erp">
          <Calculator size={tile * 0.4} strokeWidth={1.4} aria-hidden="true" />
        </span>
        <span className="mkss-app-name">{t("deinErp")}</span>
      </div>
      <div className="mkss-app mkss-app-own">
        <span className="mkss-tile mkss-tile-own">
          <BrandLogoMark width={tile} height={tile} variant="dark" />
        </span>
        <span className="mkss-app-name">{t("hausverwalterAi")}</span>
      </div>
    </div>
  );
}

/** The one line under the tiles: what the chosen way means. */
export function StageCaption(props: { readonly way: StageWay }): ReactNode {
  const t = useTranslations("marketing.scrollStage");
  return <p className="mkss-caption">{props.way === "erp" ? t("hinweisErp") : t("hinweisBuchhaltung")}</p>;
}
